import "esbuild-css-modules-plugin-ns-css:src/artifacts/shared/styles/icon/warning.module.css";

export default {
  "body": "warning-module__body_2KwFvG__010",
  "dot": "warning-module__dot_2KwFvG__010",
  "icon": "warning-module__icon_2KwFvG__010",
  "pulseWarning": "warning-module__pulse-warning_2KwFvG__010"
};
      